<template>
  <div class="mt-5">
    <b-row style="justify-content: center">
      <b-col class="text-left" cols="10">
        <b>Add Associated Individuals (Optional)</b>
        <p>
          You may add up to two (2) associated individuals below to be searched
          in conjunction with s. Should you wish to add more associated
          individuals, please contact <a href="#">support@ethixbase.com</a> to
          unlock this feature. Should you not wish to add any associated
          individual names simply click Next.
        </p>
        <b-row>
          <b-col cols="6">
            <div style="display: flex">
              <b-form-group>
                <b-form-select
                  class="w-100"
                  v-model="form.company"
                  :options="optionsCompany"
                ></b-form-select>
              </b-form-group>
              <b-form-group class="ml-1">
                <b-form-input
                  v-model="form.fullName"
                  placeholder="Full name"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="text-left d-flex p-0" cols="2">
            <p class="remove-text">Remove</p>
            <b-button class="button-sm ml-2" size="sm" variant="outline-dark">
              <b-icon-plus></b-icon-plus>
            </b-button>
          </b-col>
          <b-col cols="4">
            <b-btn
              @click="onSubmit"
              variant="success"
              style="background: #3ddc97; width: 90px"
            >
              Next
              <b-icon icon="arrow-right-short"></b-icon>
            </b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "AssociateIndividualsForm",
  data() {
    return {
      form: {
        company: null,
        fullName: null,
      },
      optionsCompany: [
        { value: null, text: "Select" },
        { value: "individual", text: "Individual" },
        { value: "company", text: "Company" },
      ],
    };
  },
  methods: {
    onSubmit() {
      this.$store.state.tabIndex++;
      this.$store.state.resultTab = false;
    },
  },
};
</script>

<style>
.remove-text:hover {
  color: red;
  cursor: pointer;
}
</style>